var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6279 28.6484C27.5313 28.6484 25 31.1798 25 34.2764V49.7236C25 52.8202 27.5313 55.3515 30.6279 55.3515H53.3744C56.4711 55.3515 59 52.8202 59 49.7236V34.2764C59 31.1798 56.4711 28.6485 53.3744 28.6485L30.6279 28.6484ZM31.9744 35.099L40.1176 43.7377C41.1023 44.6766 42.6815 44.7059 43.612 43.7614L52.054 35.0848C52.5214 34.6043 53.2898 34.5937 53.7703 35.0611C54.2508 35.5285 54.2614 36.2969 53.794 36.7774C50.9761 39.6727 48.1579 42.5688 45.3402 45.4635C43.4492 47.383 40.3514 47.3154 38.4416 45.4943C35.6987 42.5904 32.9514 39.6731 30.2083 36.7631C29.7501 36.2752 29.7734 35.5083 30.2604 35.0491C30.7973 34.5468 31.5935 34.7105 31.9744 35.099Z",
    fill: "#743FAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.52b0b4aaef29c4b56720a4d1d06a28d8.svg";
export { ForwardRef as ReactComponent };